export default "__VITE_ASSET__BDT6YaQP__"